module.exports = __webpack_public_path__ + "img/verified.110acb54.svg";